var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "formValidate",
      attrs: { model: _vm.params, "label-width": "100px", rules: _vm.rules }
    },
    [
      _c(
        "el-form-item",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.isUpdate,
              expression: "!isUpdate"
            }
          ],
          attrs: { prop: "parentId", label: _vm.$t("department.parentDept") }
        },
        [
          _c("el-input", {
            staticStyle: { width: "200px" },
            attrs: { disabled: "" },
            model: {
              value: _vm.parent.name,
              callback: function($$v) {
                _vm.$set(_vm.parent, "name", $$v)
              },
              expression: "parent.name"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { prop: "name", label: _vm.$t("department.deptName") } },
        [
          _c("el-input", {
            staticStyle: { width: "200px" },
            attrs: { type: "text", placeholder: _vm.$t("common.nameRequire") },
            model: {
              value: _vm.params.name,
              callback: function($$v) {
                _vm.$set(_vm.params, "name", $$v)
              },
              expression: "params.name"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { prop: "status", label: _vm.$t("department.deptStatus") } },
        [
          _c("zk-dictionary-select", {
            staticStyle: { width: "200px" },
            attrs: { type: "status", placeholder: _vm.$t("common.select") },
            model: {
              value: _vm.params.status,
              callback: function($$v) {
                _vm.$set(_vm.params, "status", $$v)
              },
              expression: "params.status"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { prop: "value", label: _vm.$t("common.remark") } },
        [
          _c("el-input", {
            staticStyle: { width: "200px" },
            attrs: {
              type: "text",
              placeholder: _vm.$t("common.remarkRequire")
            },
            model: {
              value: _vm.params.remark,
              callback: function($$v) {
                _vm.$set(_vm.params, "remark", $$v)
              },
              expression: "params.remark"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-33a23598", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-33a23598","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/cdpBase/baseComponents/departmentSaveOrUpdate/src/main.vue
// module id = null
// module chunks = 